import {cn} from '../../lib/utils';

import type {ComponentProps} from 'react';

export type SplitButtonProps = ComponentProps<'div'>;

/**
 * Joins a main action and a menu trigger into one pill: pass exactly two segments, the action first.
 * The pill's outer ends are rounded and its seam stays tight.
 */
export function SplitButton({className, ...props}: SplitButtonProps) {
  return (
    <div
      role="group"
      data-slot="split-button"
      className={cn(
        'inline-flex items-stretch gap-0.5',
        // Only DS segments (they carry a data-slot); Base UI adds its own spans beside an open popover.
        '[&>:nth-child(1_of_[data-slot])]:rounded-s-xl [&>:nth-child(1_of_[data-slot])]:rounded-e-[4px] [&>:nth-child(1_of_[data-slot])]:gap-2 [&>:nth-child(1_of_[data-slot])]:ps-4.5',
        '[&>:nth-last-child(1_of_[data-slot])]:w-9.5 [&>:nth-last-child(1_of_[data-slot])]:rounded-e-xl [&>:nth-last-child(1_of_[data-slot])]:rounded-s-[4px]',
        className
      )}
      {...props}
    />
  );
}
